module.exports = __webpack_public_path__ + "static/img/jd-finance-popup.aefc98a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/jd-finance-popup.png
// module id = cEXD
// module chunks = 216